import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'ticketing-digit-token',
  imports: [],
  templateUrl: './digit-token.component.html',
  styleUrl: './digit-token.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DigitTokenComponent {
  token = input.required<string>();
  tokenCharArray = computed(() => this.token().split(''));
}
